export default {"src":"/_next/static/media/mentees.6af04924.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};